"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryRulesGeneralRegion = exports.weekdayMap = exports.weekdays = exports.weekdaysMapping = void 0;
// File: deliveryRulesConstants.ts
const lodash_1 = __importDefault(require("lodash"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
moment_timezone_1.default.locale('us');
exports.weekdaysMapping = {
    mon: 1,
    '1': 'mon',
    tue: 2,
    '2': 'tue',
    wed: 3,
    '3': 'wed',
    thu: 4,
    '4': 'thu',
    fri: 5,
    '5': 'fri',
    sat: 6,
    '6': 'sat',
    sun: 0,
    '0': 'sun',
};
exports.weekdays = [
    { key: 'mon', value: 'Måndag' },
    { key: 'tue', value: 'Tisdag' },
    { key: 'wed', value: 'Onsdag' },
    { key: 'thu', value: 'Torsdag' },
    { key: 'fri', value: 'Fredag' },
    { key: 'sat', value: 'Lördag' },
    { key: 'sun', value: 'Söndag' },
];
exports.weekdayMap = lodash_1.default.keyBy(exports.weekdays, 'key');
exports.DeliveryRulesGeneralRegion = 'general';
